import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { FC } from 'react';

export const AppError: FC<TimApp.IAppContainerProps> = () => (
  <Typography component='strong' variant='h6' color='error'>
    <Box p={2} pt={7} textAlign='center'>
      Configuration error! Country not supported!
    </Box>
  </Typography>
);
